import {
  UserProfileMenu as UserProfileMenuComponent 
} from '@gisce/oficina-virtual-components';
import useAuth from '../../Authentication/hooks/useAuth';

import {
	VpnKey,
	Logout
} from "@mui/icons-material";
import { useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';
import { UserInfo } from './UserInfo';
import NewsletterUserProfileButton from '@/components/Newsletter/navigation/NewsletterUserProfileButton';
import { useSettingsContext } from '../../Settings/hooks/useSettingsContext';

export const UserProfileMenu = () => {
  const Settings = useSettingsContext();
	const { t } = useTranslation();
	const navigate = useNavigate();
  const { logout } = useAuth();

	const navigateChangePassword = () => {
    if (Settings.features?.oidc && Settings.oidc) {
      window.location.href = Settings.oidc.changePasswordUrl;
    } else {
      navigate(t('common:url.changePassword'))
    }
	}

  return (
    <UserProfileMenuComponent 
      headerComponent={<UserInfo />} 
      actions={[
        {
          label: t("common:text.change_password_view_title"),
          icon: <VpnKey />,
          onClick: () => navigateChangePassword()
        },
        ...(Settings?.newsletter?.enabled ? [NewsletterUserProfileButton()] : []),
        {
          label: t("common:text.logout_title"),
          icon: <Logout />,
          onClick: () => logout(),
        }
      ]}
    />
  );
}
